import React from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-scroll";

const Navigation = () => {
  return (
    <Navbar bg="light" expand="md" fixed="top">
      <Container fluid>
        <Link
          activeClass="active"
          to="home"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="text-dark font-weight-bold nav-link"
        >
          <Navbar.Brand className="text-dark font-weight-bold nav__brand">
            Vincenzo.dev
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle />
        <Navbar.Collapse data-testid="hamburger-menu">
          <Nav className="ml-auto">
            <Link
              activeClass="active"
              to="home"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="text-dark font-weight-bold nav-link"
              data-testid="home-link"
            >
              Home
            </Link>
            <Link
              activeClass="active"
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="text-dark font-weight-bold nav-link"
              data-testid="about-link"
            >
              About
            </Link>
            <Link
              activeClass="active"
              to="projects"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="text-dark font-weight-bold nav-link"
              data-testid="projects-link"
            >
              Projects
            </Link>
            <Link
              activeClass="active"
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="text-dark font-weight-bold nav-link"
              data-testid="contact-link"
            >
              Contact
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
